export const Constants = {
  TAG_NAME: 'pop-credit-quality-table-component',
  CREDIT_RATING_COLUMN_HEADER: 'Credit rating',
  PERCENT_OF_PORTFOLIO_COLUMN_HEADER: '% of portfolio',
  PERCENT_CHANGE_FROM_LAST_PERIOD_COLUMN_HEADER:
    '% change from previous period',
  BENCHMARK_COLUMN_HEADER: '% of benchmark',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
